import { motion } from "framer-motion";
import { IMAGES } from "@/constants/site";
import { useImageOverrides } from "@/context/ImagesContext";

const EASE = [0.22, 1, 0.36, 1];

const SPANS = [
  "md:col-span-7 aspect-[16/10]",
  "md:col-span-5 aspect-[16/10] md:aspect-auto",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-12 aspect-[16/7]",
];

const Land = () => {
  const overrides = useImageOverrides();

  return (
    <section id="land" data-testid="the-land-section" className="py-24 sm:py-32 lg:py-40 bg-forest-deep relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="eyebrow !text-gold mb-6">The Land</p>
          <h2 className="font-display font-normal text-cream text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
            Grown in the shade of a
            <span className="italic text-gold"> rainforest.</span>
          </h2>
          <p className="mt-7 text-cream/70 text-base sm:text-lg leading-relaxed">
            Everything at Masthare grows beneath the native canopy of the Western Ghats. The forest shades the
            crop, feeds the soil, and slows the ripening. We keep it standing, as it has always stood.
          </p>
        </motion.div>

        <div data-testid="land-gallery" className="mt-14 sm:mt-20 grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-6">
          {IMAGES.gallery.map((img, i) => (
            <motion.figure
              key={img.url}
              data-testid={`land-image-${i + 1}`}
              initial={{ opacity: 0, y: 44 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 3) * 0.1, ease: EASE }}
              className={`group relative overflow-hidden rounded-sm ${SPANS[i]}`}
            >
              <img
                src={overrides[`gallery_${i + 1}`] || img.url}
                alt={img.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-[1.08]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-espresso/75 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute bottom-0 left-0 p-5 flex items-center gap-3">
                <span className="h-px w-6 bg-gold" aria-hidden="true" />
                <span className="font-display italic text-cream text-lg">{img.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Land;
